import { render } from "./DevLoanMeta.vue?vue&type=template&id=5b5832c8&scoped=true&bindings={\"userId\":\"data\",\"result\":\"data\",\"error\":\"data\",\"isLoading\":\"data\",\"loaderColor\":\"data\",\"getDevForm\":\"options\",\"showLoansGuaranteed\":\"options\",\"showGuarantorRequests\":\"options\"}"
import script from "./DevLoanMeta.vue?vue&type=script&lang=js"
export * from "./DevLoanMeta.vue?vue&type=script&lang=js"

import "./DevLoanMeta.vue?vue&type=style&index=0&id=5b5832c8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5b5832c8"

export default script